import { gql } from 'graphql-request'
import { merchantServiceGraphql } from '../config/Config';


export const changePasswordGraphql = async (data) => {
  const CHANGE_PASSWORD = gql`
  mutation ChangePassword($oldPass: String!, $newPass: String!) {
    changePassword(oldPass: $oldPass, newPass: $newPass) {
      id
      username
      fullname
      phone
      email
      role
    }
  }
  `
  const response = await merchantServiceGraphql.request(CHANGE_PASSWORD, data);
  return response.changePassword;
}